/**
 * LanduseLegend - Легенда землепользования
 *
 * Мигрирована на новую систему легенд (Этап 2)
 * Использует LegendRenderer с типом COLORED_ITEMS и иконкой RECT
 *
 * DA-15980: радиокнопки источника. Старый вариант (martin.good_bad_area_mvt по тегам OSM) —
 * по умолчанию; новый — та же трёхцветка, но набранная из классов витрины
 * dwh.urban_zones_classified (пайплайн типологии территорий, DA-15202). Переключатель нужен для
 * визуального сравнения источников: расхождение по площади доходит до 56 % (Сочи), и глазами
 * оно читается быстрее, чем по цифрам. Решение о переезде не принято.
 */

import React from 'react';
import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { LegendRenderer } from '../../LegendRenderer';
import { LANDUSE_LEGEND, LANDUSE_NEW_LEGEND } from '../../../constants/legends';
import { onChangeMapFilters, onToggleLanduseCompare } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const SOURCES = [
    { value: 'old', getLabel: () => t`Старый вариант` },
    { value: 'new', getLabel: () => t`Новый вариант` },
];
const LanduseLegendComponent = ({
    mapFilters,
    onChangeMapFilters: onChangeFilters,
    onToggleLanduseCompare: onToggleCompare,
}) => {
    const compare = mapFilters.landuseCompare ?? false;
    // При включённой шторке слева всегда старый источник, справа новый, и радиокнопки ничего
    // не решают — блокируем их, чтобы не выглядели работающими.
    const source = compare ? 'old' : (mapFilters.landuseSource ?? 'old');
    const handleChange = ({ target: { value } }) => {
        onChangeFilters('landuseSource', value);
    };
    return (
        <div>
            <div className={styles.legHead}>{t`Источник`}:</div>
            <StandardRadioGroup
                value={source}
                onChange={handleChange}
            >
                {SOURCES.map(({ value, getLabel }) => (
                    <FormControlLabel
                        key={value}
                        className={classnames(styles.isochroneFilterLabel, styles.radioLabelKeepColor)}
                        control={
                            <Radio
                                checked={source === value}
                                onChange={handleChange}
                                value={value}
                                disabled={compare}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: source === value,
                                    }
                                )}
                                size="small"
                            />
                        }
                        label={getLabel()}
                    />
                ))}
            </StandardRadioGroup>
            <div className={styles.errGroupHeader}>
                <span style={{ fontSize: '15px', fontWeight: 'normal' }}>{t`Шторка сравнения`}</span>
                <label className={styles.switch}>
                    <input
                        type='checkbox'
                        checked={compare}
                        onChange={onToggleCompare}
                    />
                    <span className={classnames(styles.sliderRound, styles.slider)} />
                </label>
            </div>
            <LegendRenderer config={compare ? LANDUSE_NEW_LEGEND : (source === 'new' ? LANDUSE_NEW_LEGEND : LANDUSE_LEGEND)} />
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });

export const LanduseLegend = withDisplayedLayersCheck(
    connect(mapStateToProps, { onChangeMapFilters, onToggleLanduseCompare })(LanduseLegendComponent),
    t`Землепользование`
);
